import { motion } from "framer-motion";
import { TrendingUp, Wallet, Lock, Sparkles, HeartPulse } from "lucide-react";
import { useTranslation } from "react-i18next";

const BENEFITS = [
  { icon: TrendingUp, title: "High Capital Access", desc: "Unlock up to $250,000 in simulated capital on a 2 Step OFunded account." },
  { icon: Wallet, title: "Flexible Withdrawals", desc: "Receive your first payout instantly, with subsequent payouts available every 30 days." },
  { icon: Lock, title: "Capital Without Personal Risk", desc: "Trade simulated funds up to $250,000 — your personal funds are never at stake." },
  { icon: Sparkles, title: "Innovative Strategies", desc: "Access detailed feedback and refine strategies with help from our trading team." },
  { icon: HeartPulse, title: "Disciplined Growth", desc: "Trade under transparent rules designed to reward consistency and risk management." },
];

export default function WhyOFunded() {
  const { t } = useTranslation();
  return (
    <section data-testid="why-ofunded-section" className="relative py-14 lg:py-28">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-4 lg:sticky lg:top-28">
            <div className="pill-mono inline-flex mb-5">{t("why.pill")}</div>
            <h2 className="font-display text-4xl lg:text-5xl font-medium tracking-tight mb-6">
              {t("why.title")} <span className="text-gradient-brand">{t("why.titleAccent")}</span>
            </h2>
            <p className="text-zinc-400 leading-relaxed mb-6">
              {t("why.description")}
            </p>
            <a href="#challenges" data-testid="why-cta" className="btn-ghost-gradient">
              {t("why.cta")}
            </a>
          </div>

          <div className="lg:col-span-8 grid sm:grid-cols-2 gap-4 lg:gap-5">
            {BENEFITS.map((b, i) => (
              <motion.div
                key={b.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.08, duration: 0.45 }}
                className={`card-beam p-6 flex gap-4 ${i === 0 ? "sm:col-span-2" : ""}`}
                data-testid={`benefit-card-${i}`}
              >
                <div className="w-12 h-12 rounded-lg bg-brand/10 border border-brand/30 grid place-items-center shrink-0">
                  <b.icon className="text-brand" size={22} />
                </div>
                <div className="min-w-0">
                  <h3 className="font-display text-lg font-medium text-white mb-2 leading-tight">{b.title}</h3>
                  <p className="text-zinc-400 text-sm leading-relaxed font-light">{b.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
